module.exports = new __parcel__URL__("homebase_map_64_blob_test.d4d156fc.json").toString();